import ApplicationController from '../application_controller.js'

/*
 * Ifile transfer
 */

export default class TransferController extends ApplicationController {

  static targets = ["transferButton"]

  select_operation(e) {
    this.visit(e.target.value)
  }

  to_cfile_select_destination(e) {
    this.visit(e.target.options[e.target.selectedIndex].dataset.path)
  }

  submitForm(e) {
    var checkboxes = e.target.querySelectorAll(".record_selector")
    checkboxes.forEach(e => {
      if (!e.checked) {
        e.closest(".tr").remove()
      }
    })
  }

}